import { render } from "./ChatSvg.vue?vue&type=template&id=b6eaa4f2&ts=true"
import script from "./ChatSvg.vue?vue&type=script&lang=ts"
export * from "./ChatSvg.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__